var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.navs
    ? _c("div", { staticClass: "c-global-footer" }, [
        _c("div", { staticClass: "c-global-footer__nav-container" }, [
          _c("div", { staticClass: "l-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "l-grid l-grid--4-col l-grid--align-start u-margin-bottom-large"
              },
              [
                _vm.socialMedia
                  ? _c(
                      "div",
                      { staticClass: "l-grid__item" },
                      [
                        _c(
                          "social-media",
                          _vm._b(
                            { staticClass: "c-global-footer__social" },
                            "social-media",
                            _vm.socialMedia,
                            false
                          )
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.navs, function(nav, index) {
                  return [
                    index === 0
                      ? _c(
                          "global-footer-nav",
                          { key: "nav-item-" + index, attrs: { nav: nav } },
                          [!_vm.isCrawler ? _vm._t("default") : _vm._e()],
                          2
                        )
                      : _c("global-footer-nav", {
                          key: "nav-item-" + index,
                          attrs: { nav: nav }
                        })
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "l-flex " },
              [
                _vm._l(_vm.footerImages, function(img, index) {
                  return _c(
                    "div",
                    {
                      key: "footer-image-" + index,
                      staticClass: "c-global-footer__footer-image-wrapper"
                    },
                    [
                      _c("img", {
                        staticClass: "c-global-footer__footer-image",
                        attrs: { src: img.src, alt: img.alt || img.title }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._m(0)
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _vm.copyright
          ? _c("div", { staticClass: "c-global-footer__copyright-container" }, [
              _c(
                "p",
                { staticClass: "c-global-footer__copyright t-paragraph-small" },
                [_vm._v("\n      " + _vm._s(_vm.dynamicCopyright) + "\n    ")]
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-global-footer__yotpo-badge-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "yotpo yotpo-badge badge-init",
          attrs: { id: "y-badges" }
        },
        [_vm._v("\n \n          ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }